export class ProviderBillingId {
	provider: string;
	billingId: string;

	//for GUI use
	selected: string;
}